var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTouchZoom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "800px",
    height: "800px",
    viewBox: "0 0 140 140",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.044 84.941s-.28-1.324.578-.72l2.954 2.06.87-1.317a8980.31 8980.31 0 005.406-8.117s.188-.538.864-.063c.683.472 6.206 4.33 6.693 4.669.483.34.22.718.22.718-1.094 1.642-3.95 5.93-5.42 8.133-.469.711-.783 1.178-.783 1.178s1.679 1.168 2.729 1.901c1.043.733-.284.988-.284.988S4.124 96.427 3.078 96.63c-.757.145-.847-.666-.847-.666z",
    fill: "#65ff00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.919 16.854c-5.85 0-10.592 4.862-10.592 10.86 0 5.997 4.742 10.859 10.593 10.859 5.849 0 10.59-4.862 10.59-10.86 0-5.997-4.742-10.86-10.591-10.86zm0 19.47c-4.638 0-8.4-3.856-8.4-8.612 0-4.754 3.762-8.61 8.4-8.61 4.637 0 8.397 3.856 8.397 8.61 0 4.756-3.76 8.612-8.397 8.612zM23.24 56.175c-5.457 0-9.88 4.703-9.88 10.505 0 5.8 4.424 10.504 9.881 10.504s9.88-4.703 9.88-10.504c0-5.802-4.424-10.505-9.88-10.505zm0 18.833c-4.325 0-7.835-3.73-7.835-8.33 0-4.598 3.51-8.328 7.835-8.328 4.326 0 7.834 3.73 7.834 8.329 0 4.6-3.507 8.33-7.834 8.33z",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M89.48 111.784l-1.887 6.648-38.778-.368c0-.001 2.83-2.586-2.125-7.016 0 0-10.823-5.226-18.507-18.097 0 0-6.31-6.742-6.092-9.207-.583-4.408-1.21-6.955-1.715-8.535-1.064-4.04-1.553-2.844-1.553-7.228 2.452-14.334 10.869 1.81 12.764 5.488 0 0 6.305 7.579 9.063 9.284 8.851-2.292 3.039-22.11 3.66-23.669 0 0-1.25-10.043-2.821-23.064-3.995-15.562 8.286-19.627 11.636-3.094 1.545 7.345 3.687 19.527 4.483 19.775 0 0 8.395-7.385 12.996 3.323 0 0 9.202-5.539 12.742 5.17 0 0 12.387 1.107 11.326 12.924 0 0 2.595 22.157-5.191 37.666z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.854 14.904c.696.466 6.36 4.268 6.858 4.604.492.334.749-.054.749-.054 1.121-1.618 4.045-5.845 5.546-8.014.488-.703.803-1.165.803-1.165l2.792 1.877c1.076.722.814-.62.814-.62s-1.732-9.9-1.933-10.954c-.15-.762-.94-.551-.94-.551l-11.085 1.91s-1.337.214-.455.805c.889.593 3.025 2.03 3.025 2.03s-.355.508-.896 1.294a8852.21 8852.21 0 00-5.539 7.998c-.001.002-.434.37.261.84z",
    fill: "#65ff00"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTouchZoom);
export default __webpack_public_path__ + "static/media/TouchZoom.7c0cbbb22cb0caefb537528a428bbed8.svg";
export { ForwardRef as ReactComponent };